import { SeeMoreBlock } from "components/blocks/SeeMoreBlock";
import { TagLink } from "components/widgets/TagList/TagLink";
import { ITag } from "@/common/services/types";
import { routes } from "@/common/utils/routes";
import { metricsBus } from "@/common/buses";

export interface IRelatedTagsProps {
  tags: string[];
}

export const RelatedTags = (props: IRelatedTagsProps) => {
  const tags = props.tags.map(tag => ({
    name: tag,
    count: 0,
  }));

  const onSendMetrics = (targetURL: string) => {
    metricsBus.emit("watchPageNavigation", { elementType: "Tag", targetURL });
  };

  return (
    <SeeMoreBlock
      header="🔥️ Related Tags"
      more={routes.trendingTags()}
      className="trendingTags canvas"
      list={true}
    >
      {tags.map((tag: ITag) => (
        <TagLink
          key={tag.name}
          tag={tag}
          counts={false}
          onSendMetrics={() => onSendMetrics(routes.singleTag(tag.name))}
        />
      ))}
    </SeeMoreBlock>
  );
};
